export const DARK_THEME_MODE_TYPE = 'dark';
export const LIGHT_THEME_MODE_TYPE = 'light';

export const MODULOR_ASSETS_PATH = '/mdlr';
